import React, {useEffect, useState} from 'react';
import {withRouter} from 'react-router-dom';
import {Button, Popconfirm, Table, Drawer, Space, Form, Input, notification, Alert, Spin} from "antd";
import {faPlus} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import HelperGeneral from "../../../../helpers/HelperGeneral";
import {trans} from "../../../../helpers/HelperGlobal";
import MaskedInput from "antd-mask-input";
import Countdown, {zeroPad} from "react-countdown";
import Api from "../../../../services/Api";
import UserInfo from "../../../auth/UserInfo";
import moment from "moment";
import {Col, Container, Row} from "react-bootstrap";
import {useWindowWidth} from "../../../helpers/useWindowWidth";

const AddPharmacyAgent = () => {
    const [info, setInfo] = useState({});
    const [userRegisterData, setUserRegisterData] = useState({});
    const [step, setStep] = useState(1);
    const [open, setOpen] = useState(false);
    const [loading, setLoading] = useState(true);
    const [modalLoading, setModalLoading] = useState(false);
    const [tableData, setTableData] = useState([]);
    const [date, setDate] = useState(null);
    const [pagination, setPagination] = useState({current: 1, pageSize: 10});
    const user = UserInfo.info();
    const [form] = Form.useForm();
    const windowWidth = useWindowWidth();

    const columns = [
        {
            title: 'Adı Soyadı',
            dataIndex: 'firstName',
            render: (name, record) => record?.firstName ? record?.lastName ? record?.firstName + ' ' + record?.lastName : record?.firstName : '-',
            width: 200,
        },
        {
            title: 'Telefon Numarası',
            dataIndex: 'gsm',
            render: (name, record) => record?.gsm ?? '-',
            width: 200,
        },
        {
            title: 'E-Posta Adresi',
            dataIndex: 'email',
            width: 180,
            render: (name, record) => record?.email && record?.email?.length > 0 ? record?.email : '-',
        },
        {
            title: 'Q Puanı',
            dataIndex: 'email',
            width: 180,
            render: (name, record) =>
                <div style={{display: "flex", alignItems: "center"}}>
                    {record?.currentPoint ?? '0'}
                    <img
                        src={require('../../../../assets/images/png/theme/q-point-logo.png')}
                        style={{width: '22px', height: '22px', borderRadius: '4px', marginRight: '5px', marginLeft: '5px'}}
                    />
                </div>,
        },
        {
            title: 'İşlem Tarihi',
            dataIndex: 'createdOn',
            sorter: false,
            width: 180,
            render: (name, record) => moment(record?.createdAt).format('DD.MM.YYYY HH:mm'),
        },
    ];

    useEffect(() => {
        getPharmacyGetContacts();
    }, [])

    const getPharmacyGetContacts = (page = pagination?.current, size = pagination?.pageSize) => {
        setLoading(true);
        Api.getPharmacyGetContacts(page, size).then((e) => {
            setLoading(false);
            setTableData(e?.data?.data[0]?.users);
        }).catch(e => {
            HelperGeneral.alert(e);
            setLoading(false);
        })
    }

    const saveContactSubmit = (e) => {
        setModalLoading(true);

        if (step === 1) {
            setModalLoading(false);
            setStep(2);
            setUserRegisterData(e);
            setModalLoading(false);
        } else if (step === 2) {
            setModalLoading(true);

            let data = {
                telephone: e?.mobilePhone,
                type: 'register',
                sendType: 'sms',
            }
            Api.createContactOtp(data).then(r => {
                setDate(Date.now() + (r?.data?.expired * 1000));
                userRegisterData.telephone = e?.mobilePhone;
                setStep(3);
                setUserRegisterData(userRegisterData);
                setModalLoading(false);
            }).catch((e) => {
                setModalLoading(false);
                HelperGeneral.alert(e);
            })
        } else if (step === 3) {
            setModalLoading(true);

            userRegisterData.type = info?.sendType;
            userRegisterData.code = e?.code;

            let data = {
                operation_type: 'register',
                telephone: userRegisterData?.telephone,
                code: userRegisterData?.code,
                send_type: 'sms',
            };

            Api.verifyOtp(data).then(r => {
                userRegisterData.otpCode = e?.code;
                setStep(4);
                setInfo(r?.data?.result);
                setUserRegisterData(userRegisterData);
                setModalLoading(false);
            }).catch((e) => {
                setModalLoading(false);
                HelperGeneral.alert(e);
            })
        } else if (step === 4) {
            setModalLoading(true);

            let data = {
                telephone: user?.gsm,
                type: 'remember',
                sendType: 'sms',
            }
            Api.createContactOtp(data).then(r => {
                setDate(Date.now() + (r?.data?.expired * 1000));
                setStep(5);
                setModalLoading(false);
            }).catch((e) => {
                setModalLoading(false);
                HelperGeneral.alert(e);
            })
        } else if (step === 5) {
            setModalLoading(true);

            userRegisterData.type = info?.sendType;
            userRegisterData.code = e?.pharmacistCode;

            let data = {
                operation_type: 'remember',
                telephone: user?.gsm,
                code: userRegisterData?.code,
                send_type: 'sms',
            };

            Api.verifyOtp(data).then(r => {
                setStep(6);
                setModalLoading(false);
            }).catch((e) => {
                setModalLoading(false);
                HelperGeneral.alert(e);
            })
        } else if (step === 6) {
            setModalLoading(true);
            userRegisterData.password = e?.password;

            const data = {
                email: userRegisterData?.email,
                first_name: userRegisterData?.firstName,
                last_name: userRegisterData?.lastName,
                password: userRegisterData?.password,
                gsm: userRegisterData?.telephone,
                company_id: user?.company_id,
                user_roles_id: 6,
                active: 1
            }

            Api.userCreate(data).then(r => {
                setInfo({});
                setUserRegisterData({});
                setModalLoading(false);
                setOpen(false);
                getPharmacyGetContacts();
                notification['success']({
                    message: 'Başarılı!',
                    description: 'Yetkili başarıyla eklendi',
                });
            }).catch((e) => {
                setModalLoading(false);
                HelperGeneral.alert(e);
            })
        }
    }

    const onClose = () => {
        setOpen(false);
        setDate(null);
        setStep(1);
        form.resetFields();
    }

    const handleTableChange = (e) => {
        setPagination(e);
        getPharmacyGetContacts(e?.current, e?.pageSize);
    }

    const passwordComplexityValidator = (_, value) => {
        if (!value || value.length < 8) return Promise.resolve();

        const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^\w\s]).+$/;

        if (!regex.test(value)) {
            return Promise.reject(
                new Error(
                    trans("Şifreniz en az 1 büyük harf, 1 küçük harf, 1 rakam ve 1 özel karakter içermelidir.")
                )
            );
        }

        return Promise.resolve();
    };

    let buttonTitle = 'Kaydet ve Devam Et';
    let help = null;
    if (step === 2) {
        buttonTitle = 'Kod Gönder';
        help = 'Lütfen sisteme kaydetmek istediğiniz telefon numaranısını bu alana giriniz. Şifrenizi oluştabilmek için SMS kodununun doğrulanması istenecektir.';
    } else if (step === 3) {
        buttonTitle = 'Kodu Doğrula';
    } else if (step === 4) {
        buttonTitle = 'Kod Gönder';
        help = 'Girilen telefon doğrulandı. 2. Doğrulama için hesaba kayıtlı olan telefona SMS kodu gönderilecektir.';
    } else if (step === 5) {
        buttonTitle = 'Kodu Doğrula';
    } else if (step === 6) {
        buttonTitle = 'Şifreni Oluştur ve Yetkili Kaydını Tamamla';
    }

    return (
        <Container className={'p-0'}>
            <Row>
                <Col xs={12} md={12} className={"col-12 col-md-12 mb-3"}>
                    <Alert
                        message={null}
                        description={"Yetki verilen kişiler, giriş yaptıktan sonra sistemdeki tüm özellikleri kullanabilecektir."}
                        type={"info"}
                        showIcon={true}
                    />
                </Col>
                <Col xs={12} className={"d-flex justify-content-end"}>
                    <Button
                        className={'btn btn-primary text-white h-100'}
                        style={{background: "#063041", borderColor: '#063041'}}
                        onClick={() => setOpen(true)}
                    >
                        Yetkili Ekle &nbsp; <FontAwesomeIcon icon={faPlus}/>
                    </Button>
                </Col>
                <Col xs={12}>
                    <div className={'box authorized-user-list'} style={{maxWidth: 'initial'}}>
                        <h4 className={"mb-3"}>Eczane Yetkili Listesi</h4>
                        <Table
                            columns={columns}
                            rowKey={record => record.Id}
                            dataSource={tableData}
                            loading={loading}
                            pagination={{
                                ...pagination,
                                showSizeChanger: true,
                                pageSizeOptions: ['15', '30', '45', '60', '100'],
                                responsive: false,
                            }}
                            onChange={(e) => handleTableChange(e)}
                        />
                    </div>
                </Col>
            </Row>
            <Drawer
                title={"Yetkili Ekle"}
                placement={'right'}
                width={windowWidth > 400 ? 400 : '100%'}
                onClose={onClose}
                visible={open}
                extra={<Space/>}
            >
                <Spin spinning={modalLoading}>
                    <div className={'form-area basket'}>
                        <Form
                            form={form}
                            name={'login'}
                            initialValues={{pharmacistMobilePhone: user?.gsm}}
                            onFinish={(e) => saveContactSubmit(e)}
                            layout={'vertical'}
                        >
                            {
                                step === 1 && (
                                    <>
                                        <Form.Item
                                            label={"Adı"}
                                            name={"firstName"}
                                            rules={[{required: true}]}
                                        >
                                            <Input/>
                                        </Form.Item>
                                        <Form.Item
                                            label={"Soyadı"}
                                            name={"lastName"}
                                            rules={[{required: true}]}
                                        >
                                            <Input/>
                                        </Form.Item>
                                        <Form.Item
                                            label={"E-posta Adresi"}
                                            name={"email"}
                                            rules={[{required: true, type: 'email'}]}
                                        >
                                            <Input/>
                                        </Form.Item>
                                    </>
                                )
                            }
                            {
                                step === 2 && (
                                    <Form.Item
                                        name={'mobilePhone'}
                                        label={"Eklenecek Yetkilinin Telefon Numarası"}
                                        rules={[
                                            {
                                                validator: (_, value) => {
                                                    const digits = String(value || "").replace(/\D/g, "");

                                                    if (digits.length === 0) {
                                                        return Promise.reject(
                                                            new Error("Telefon numarası zorunludur")
                                                        );
                                                    }

                                                    if (digits.length !== 12) {
                                                        return Promise.reject(
                                                            new Error("Telefon numarasını eksiksiz giriniz")
                                                        );
                                                    }

                                                    return Promise.resolve();
                                                },
                                            },
                                        ]}
                                        help={help}
                                    >
                                        <MaskedInput
                                            mask={'(\\+90)111-111-11-11'}
                                            autoComplete={'new-password'}
                                            disabled={step === 3}
                                        />
                                    </Form.Item>
                                )
                            }
                            {
                                step === 3 && (
                                    <>
                                        <div className={'password-reset'}>
                                            {trans('t3')}
                                            <span className={'time'}>
                                                <Countdown
                                                    precision={0}
                                                    renderer={({minutes, seconds}) => (
                                                        <span>
                                                            {trans('t2', {minutes: zeroPad(minutes), seconds: zeroPad(seconds)})}
                                                        </span>
                                                    )}
                                                    onComplete={() => {
                                                        setStep(step - 1);
                                                        setDate(null);
                                                        if (step === 3) {
                                                            HelperGeneral.alert('Doğrulama süresi sona erdi.');
                                                        }
                                                    }}
                                                    date={date}
                                                />
                                            </span>
                                        </div>
                                        <Form.Item
                                            name={'code'}
                                            rules={[
                                                () => ({
                                                    validator(_, value) {
                                                        const v = HelperGeneral.telephoneClear(value);
                                                        if (v.length === 5) {
                                                            return Promise.resolve()
                                                        }
                                                        return Promise.reject(
                                                            new Error(trans('login.t22')))
                                                    },
                                                })]}
                                            help={'Girilen telefona gönderilen 5 haneli onay kodunu giriniz.'}
                                        >
                                            <MaskedInput
                                                mask={'11111'}
                                                autoComplete={'new-password'}
                                                size={5}
                                            />
                                        </Form.Item>
                                    </>
                                )
                            }
                            {
                                step === 4 && (
                                    <Form.Item
                                        name={'pharmacistMobilePhone'}
                                        label={"Hesaba Kayıtlı Telefon Numarası"}
                                        rules={[() => ({required: false})]}
                                        help={help}
                                    >
                                        <MaskedInput
                                            mask={'(\\+90)111-111-11-11'}
                                            autoComplete={'new-password'}
                                            disabled={true}
                                        />
                                    </Form.Item>
                                )
                            }
                            {
                                step === 5 && (
                                    <>
                                        <div className={'password-reset'}>
                                            {trans('t3')}
                                            <span className={'time'}>
                                                <Countdown
                                                    precision={0}
                                                    renderer={({minutes, seconds}) => (
                                                        <span>
                                                            {trans('t2', {minutes: zeroPad(minutes), seconds: zeroPad(seconds)})}
                                                        </span>
                                                    )}
                                                    onComplete={() => {
                                                        setStep(step - 1);
                                                        setDate(null);
                                                        if (step === 5) {
                                                            HelperGeneral.alert('Doğrulama süresi sona erdi.');
                                                        }
                                                    }}
                                                    date={date}
                                                />
                                            </span>
                                        </div>
                                        <Form.Item
                                            name={'pharmacistCode'}
                                            rules={[
                                                () => ({
                                                    validator(_, value) {
                                                        const v = HelperGeneral.telephoneClear(value);
                                                        if (v.length === 5) {
                                                            return Promise.resolve()
                                                        }
                                                        return Promise.reject(
                                                            new Error(trans('login.t22')))
                                                    },
                                                })]}
                                            help={'Hesaba kayıtlı telefona gönderilen 5 haneli onay kodunu giriniz.'}
                                        >
                                            <MaskedInput
                                                mask={'11111'}
                                                autoComplete={'new-password'}
                                                size={5}
                                            />
                                        </Form.Item>
                                    </>
                                )
                            }
                            {
                                step === 6 && (
                                    <>
                                        <Form.Item
                                            name="password"
                                            label={trans("t11")}
                                            validateFirst
                                            rules={[
                                                {required: true, message: trans("t14")},
                                                {min: 8, message: trans("t14")},
                                                {validator: passwordComplexityValidator},
                                            ]}
                                        >
                                            <Input.Password autoComplete="new-password"/>
                                        </Form.Item>
                                        <Form.Item
                                            name="new_password_confirm"
                                            label={trans('t12')}
                                            rules={[
                                                {required: true, message: trans('t15')},
                                                ({getFieldValue}) => ({
                                                    validator(_, value) {
                                                        if (!value || getFieldValue('password') === value) {
                                                            return Promise.resolve();
                                                        }
                                                        return Promise.reject(
                                                            new Error(trans('Şifreler uyuşmamaktadır'))
                                                        );
                                                    },
                                                }),
                                            ]}
                                        >
                                            <Input.Password autoComplete="new-password"/>
                                        </Form.Item>
                                    </>
                                )
                            }
                            <Form.Item className={"text-center"}>
                                <Button
                                    type={"primary"}
                                    htmlType={"submit"}
                                    style={{height: 46}}
                                    className={"login-form-button mt-2"}
                                >
                                    {buttonTitle}
                                </Button>
                            </Form.Item>
                        </Form>
                    </div>
                </Spin>
            </Drawer>
        </Container>
    )
}

export default withRouter(AddPharmacyAgent);
